import { Landing } from "./pages";

function App() {
  return <Landing />;
}

export default App;
